document.addEventListener("DOMContentLoaded", () => {
  // Login direkt submit oluyor, OTP kontrolu sadece register icin
  if (!customElements.get("byte-otp-login")) {
    class ByteOtpLogin extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        if (!this.form) return;
        this.init();
      }
      init() {
        // Login formu direkt submit olsun
      }
    }
    customElements.define("byte-otp-login", ByteOtpLogin);
  }

  if (!customElements.get("byte-otp-register")) {
    class ByteOtpRegister extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        if (!this.form) return;
        this.modal = document.querySelector(".otp-modal");
        this.errorList = this.querySelector(".Alert__ErrorList");
        this.formAlert = this.querySelector(".Form__Alert");
        this.init();
      }
      init() {
        console.log(this.form);
        this.form.addEventListener("submit", async (e) => {
          e.preventDefault();
          this.handleFromSubmit(e);
        });
      }
      async handleFromSubmit() {
        this.formAlert.classList.add("hidden");
        const email = this.form.querySelector(
          "input[name='customer[email]']"
        ).value;
        const phone = this.form.querySelector(
          "input[name='customer[note][phone]']"
        ).value;
        const birthday = this.form.querySelector(
          "input[name='customer[note][birthday]']"
        ).value;

        // check phone
        const checkData = await fetch(
          "/apps/godiva-otp-auth/api/otp/register/check",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ phone, email }),
          }
        );
        const checkDataResponse = await checkData.json();
        if (!checkDataResponse.success) {
          this.errorList.innerHTML = "";
          const error = document.createElement("li");
          error.textContent = "Telefon numarası zaten mevcut";
          error.classList.add("Alert__ErrorItem");
          this.errorList.appendChild(error);
          this.formAlert.classList.remove("hidden");
          return;
        } else {
          this.modal.showModal(this, "register", email, phone, birthday);
        }
      }
      submit (){
        this.form.submit();
      }
    }
    customElements.define("byte-otp-register", ByteOtpRegister);
  }
  if (!customElements.get("byte-otp-modal")) {
    class ByteOtpModal extends HTMLElement {
      constructor() {
        super();
        this.inputPhone = this.querySelector("input[name='otp-phone']");
        this.inputCode = this.querySelector("input[name='otp-code']");
        this.buttonSend = this.querySelector(".otp-button[data-send]");
        this.buttonValidate = this.querySelector(".otp-button[data-validate]");
        this.phoneSection = this.querySelector(".otp-modal-phone-input");
        this.codeSection = this.querySelector(".otp-modal-code-input");
        this.closeButton = this.querySelector(".otp-modal-close");
        this.description = this.querySelector(".otp-modal-description");
        this.error = this.querySelector(".otp-modal-error");
        this.init();
      }
      init() {
        this.closeButton.addEventListener("click", (e) => {
          e.preventDefault();
          this.hideModal();
        })

        this.inputCode.addEventListener("change", (e) => {
          this.code = e.target.value;
        });
        this.inputCode.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            this.submitOtp();
          }
        });
        this.inputPhone.addEventListener("keydown", (e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            this.submitPhone();
          }
        });
        this.inputPhone.addEventListener("change", (e) => {
          this.phone = e.target.value;
        });

        this.buttonSend.addEventListener("click", (e) => {
          e.preventDefault();
          this.submitPhone();
        });

        this.buttonValidate.addEventListener("click", (e) => {
          e.preventDefault();
          this.submitOtp();
        });
      }

      async showModal(targetElement, type = "", email = "", phone = "", birthday = "") {
        this.targetElement = targetElement;
        this.type = type;
        this.email = email;
        this.phone = phone;
        this.birthday = birthday;
        this.inputPhone.value = phone;
        this.inputCode.value = "";
        this.error.classList.add("hidden");
        this.classList.add("active");
        document.body.style.overflow = "hidden";

        if (type === "register") {
          // Register flow'unda telefon zaten formdan geliyor, direkt kod gönder
          this.phoneSection.classList.add("hidden");
          this.codeSection.classList.add("hidden");

          const submitCodeResponse = await fetch(
            "/apps/godiva-otp-auth/api/otp/send",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ phone: this.phone }),
            }
          );
          const submitCodeResponseData = await submitCodeResponse.json();
          if (submitCodeResponseData.success) {
            this.codeSection.classList.remove("hidden");
            this.description.textContent = "Telefonunuza gelen doğrulama kodunu giriniz";
          } else {
            this.phoneSection.classList.remove("hidden");
          }
        }
      }

      hideModal() {
        this.classList.remove("active");
        document.body.style.overflow = null;
        this.description.textContent = "Hesabınızı doğrulamak için telefon numaranızı girin.";
      }

      async submitPhone() {
        const submitCodeResponse = await fetch(
          "/apps/godiva-otp-auth/api/otp/send",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ phone: this.phone }),
          }
        );
        const submitCodeResponseData = await submitCodeResponse.json();
        if (submitCodeResponseData.success) {
          this.codeSection.classList.remove("hidden");
          this.phoneSection.classList.add("hidden");
          this.description.textContent = "Telefonunuza gelen doğrulama kodunu giriniz";
        } else {
          this.error.classList.remove("hidden");
          this.error.textContent = submitCodeResponseData.error;
        }
      }

      async submitOtp() {
        let response;
        const code = this.inputCode.value;

        if (this.type === "register") {
          response = await fetch("/apps/godiva-otp-auth/api/otp/verify", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              phone: this.phone,
              otp: code,
            }),
          });
        }

        const responseData = await response.json();

        if (responseData.success) {
          if (this.type === "register") {
            const registerResponse = await fetch("/apps/godiva-otp-auth/api/save-info/register", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                email: this.email,
                phone: this.phone,
                bdate: this.birthday,
              }),
            });
            const registerResponseData = await registerResponse.json();
            if (registerResponseData.success) {
              console.log("Register response data", registerResponseData);
            } else {
              this.error.classList.remove("hidden");
              this.error.textContent = registerResponseData.error;
              return;
            }
            this.preventClose = false;
            this.hideModal();
            this.targetElement.submit();
          }
        } else {
          this.error.classList.remove("hidden");
          if (responseData.error === "Invalid OTP") {
            this.error.textContent = "Doğrulama kodu hatalı";
          } else {
            this.error.textContent = responseData.error;
          }
        }
      }
    }
    customElements.define("byte-otp-modal", ByteOtpModal);
  }
});
